import { render, staticRenderFns } from "./WitnessStatisticsList.vue?vue&type=template&id=405b793e&"
import script from "./WitnessStatisticsList.vue?vue&type=script&lang=js&"
export * from "./WitnessStatisticsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports